import { z } from "zod";

export const getInvoicesQuerySchema = z.object({
	state: z.enum(["paid", "overdue", "pending", "all"]).default("all"),
});

export type GetInvoicesQuerySchema = z.infer<typeof getInvoicesQuerySchema>;
